import { GlCheckbox, GlCheckboxProps } from '@adl/component-checkbox'
import { useTranslations } from '@crystal/translator'
import { FC, useEffect, useState, ChangeEvent } from 'react'

export const KmcDataStorageConsent: FC<GlCheckboxProps> = props => {
  const t = useTranslations()
  const [isChecked, setIsChecked] = useState(false)

  useEffect(() => {
    if (!props.onChange) {
      return
    }

    // notify the initial value
    props.onChange({
      target: {
        type: 'checkbox',
        name: props.name,
        checked: isChecked,
      },
    } as ChangeEvent<HTMLInputElement>)
  }, [])

  const onChange = (event: ChangeEvent<HTMLInputElement>) => {
    setIsChecked(event.target.checked)
    props.onChange && props.onChange(event)
  }

  const { className, ...restProps } = props

  return (
    <>
      <div className={className} />
      <p className="gl-vspace-bpall-small">{t('kmc.dataStorageConsent.title')}</p>
      <div className="gl-vspace">
        <GlCheckbox
          data-auto-id="kmc-data-storage-consent"
          label={t('kmc.dataStorageConsent.label')}
          onChange={onChange}
          isChecked={isChecked}
          {...restProps}
        />
      </div>
      <p>{t('kmc.dataStorageConsent.footnote')}</p>
      <div className="gl-vspace-bpall-medium" />
    </>
  )
}
